import { Grid, Tab, Tabs } from '@mui/material';
import { Link, Route, Switch, useLocation } from 'react-router-dom';
import { MDBox } from '../../../Component/Common/Components/MDBox';
import { MDTypography } from '../../../Component/Common/Components/MDTypography';
import { vaBBBEEmodule } from '../../../Component/Common/Constants/routes';
import { useRouteMatch } from '../../../Helpers/RouteMatcher';
import { ScorecardSubmissionManagementPage } from '../ScorecardSubmission/ScorecardSubmissionManagementPage';
import { DataPageAccessRequestBasePage } from '../../VerificationAgency/Incoming/DataPageAccessRequests/DataPageAccessRequestsBasePage';
import { DataPageSubmissionStatus } from '../../../Component/Model/Enum/BEE123Enums';
import { DataPageSubmissionsBasePage } from '../../VerificationAgency/Incoming/DataPageSubmissions/DataPageSubmissionsBasePage';
import config from '../../../config';

export const IncomingBasePage = () => {
    const location = useLocation();
    let subHeading: string = '';
    const routes = [
        `/${vaBBBEEmodule.incoming}/scorecardSubmissions`,
        `/${vaBBBEEmodule.incoming}/dataPageSubmissions`,
        `/${vaBBBEEmodule.incoming}/accessRequests`,
    ]

    const routeMatch = useRouteMatch(routes);
    let currentTab = routeMatch?.path;
    if (currentTab == null) {
        if (location.pathname.includes(routes[0])) {
            currentTab = routes[0];
            subHeading = '';
            
        }
        else if(location.pathname.includes(routes[1])) {
            currentTab = routes[1];
            subHeading = 'The following companies have requested to edit data pages';
        }
        else if(location.pathname.includes(routes[2])) {
            currentTab = routes[2];
            subHeading = 'The following companies have requested to edit data pages';
        }
    }

    return (
        <>
            <MDBox style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                <MDTypography variant='h4' fontWeight='bold' >
                    Incoming
                </MDTypography>
            </MDBox>
            <MDBox style={{ paddingBottom: "12px" }}>
                <MDTypography variant='body2' fontWeight='normal'>
                    {subHeading}
                </MDTypography>
            </MDBox>
            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        {config.enable_VAScorecardSubmissionProccess === 'true' && 
                            <Tab label="Scorecard Submissions" value={routes[0]} to={routes[0]} component={Link} />
                        }
                        <Tab label="Data Page Submissions" value={routes[1]} to={routes[1]} component={Link} />
                        <Tab label="Access Requests" value={routes[2]} to={routes[2]} component={Link} />
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={1}>
                    <Switch>
                        <Route path={routes[0]}>
                            <ScorecardSubmissionManagementPage />
                        </Route>
                        <Route path={routes[1]}>
                            <DataPageSubmissionsBasePage/>
                        </Route>
                        <Route path={routes[2]}>
                            <DataPageAccessRequestBasePage />
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </>
    );
}